import { useWorkspaceMembers } from './useWorkspaceMembers';

export const useBillableUsersCount = () => {
  const { members } = useWorkspaceMembers();

  if (!members) {
    return {
      totalBillableMembers: 0,
      totalBillableGuests: 0,
      totalBillableSeats: 0,
      totalNonBillableSeats: 0,
    };
  }

  const billableMembersEmails = new Set(members.billableMembers.map((m) => m.email));
  // Guests with 'Can Comment' or 'Can Edit' permissions are billable.
  const nonMemberBillableGuests = new Set(
    members.billableGuests.filter((m) => !billableMembersEmails.has(m.email)).map((m) => m.email),
  );

  const nonBillableUsers = new Set([
    ...members.nonBillableMembers.filter((m) => !nonMemberBillableGuests.has(m.email)).map((m) => m.email),
    ...members.nonBillableGuests.filter((m) => !billableMembersEmails.has(m.email)).map((m) => m.email),
  ]);

  const totalBillableMembers = members.billableMembers.length;
  const totalBillableGuests = nonMemberBillableGuests.size;
  const totalBillableSeats = totalBillableMembers + totalBillableGuests;

  const totalNonBillableSeats = nonBillableUsers.size;

  return {
    totalBillableMembers,
    totalBillableGuests,
    totalBillableSeats,
    totalNonBillableSeats,
  };
};
